import { css } from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const box = ({ theme, type, color }) => css`
  border: ${theme[type].border};
  box-shadow: ${theme[type].shadow};
  ${theme[type].background ? `background-color: ${color || theme[type].background};` : ''}
  border-radius: ${theme[type].radius};
`;
